<template>
  <div class="text-center mx-auto px-[10px] sm:px-5 md:px-10 w-full relative top-0 overflow-y-auto">
    <div class="h-[100vh] flex justify-center items-center flex-col gap-[30px]">
      <a @click.prevent="resetPage" class="flex items-center router-link-active">
        <img src="/images/geeq-explore-14-14@2x.png" class="flex items-center m-auto router-link-active max-w-[500px] min-w-[300px]" />
      </a>
      <div class="mt-[70px]">
        <search-form ref="form" />
      </div>
    </div>
    <section class="stats-section pb-[100px] mt-[50px]">
      <!-- <HeadingComponent text="Geeq Blockchain Explorer"
        class="text-left text-[33px] font-jost-regular text-blue-light break-all leading-[47px]" /> -->
        Admin mobile page
    </section>
  </div>

</template>

<script>
import { defineComponent } from 'vue';
import { formatDate } from '@/helpers/date';

// import HeadingComponent from '@/components/web/HeadingComponent.vue';
import SearchForm from '@/components/web/SearchForm';

export default defineComponent({
  name: 'AdminPage',
  components: { 
    SearchForm, 
    // HeadingComponent
  },
  created() {
    // const data = {
    //   searchType: 'Metadata',
    //     search: '',
    //     searchStrType: 'meta',
    //     isExactMatch: false,
    // };
    // this.$store.commit('setSearchSettings', data)
    // this.$store.commit('resetSearchData')
  },
  methods: {
      formatDate(d) {
      return formatDate(d);
    },
    resetPage() {
      this.$refs.form.resetForm()
    }
  }
});
</script>

<style lang="scss" scoped>
.stats-section {
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Dynamic column widths */
//   gap: 20px; /* Space between cards */
}
</style>
